'use strict';

var TrueODController = function TrueODController($scope, $filter, trueODService, featureToggleService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  $scope.market = $scope.entityData.market;
  $scope.departureDate = rmMomentFormat($scope.entityData.departureDateMoment, 'DATE_USER_SETTINGS');
  var tripBooking = featureToggleService.isEnabled('MAPPED_MODE') ? $scope.entityData.regularTripBooking : $scope.entityData.mappedTripBooking;
  if (tripBooking) {
    $scope.rows = trueODService.transformToRows(tripBooking, $scope.entityData.carrier);
  }
};
TrueODController.$inject = ['$scope', '$filter', 'TrueODService', 'FeatureToggleService'];
module.exports = TrueODController;